module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fb_selected),
      expression: "fb_selected"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.fb_selected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.fb_users), function(fb, index) {
    return (fb.id) ? _c('option', {
      domProps: {
        "value": index
      }
    }, [_vm._v(_vm._s(fb.firstname) + " " + _vm._s(fb.lastname) + " | id: " + _vm._s(fb.id))]) : _vm._e()
  })), _vm._v(" "), (_vm.fb_selected >= 0) ? _c('div', [_c('h3', [_vm._v("Ovaj korisnik se gasi i menja se sa korisnikom desno:")]), _vm._v(" "), _c('p', [_vm._v("Odabran korisnik: "), _c('a', {
    attrs: {
      "href": 'https://facebook.com/' + _vm.fb_users[_vm.fb_selected].facebook_id
    }
  }, [_vm._v(_vm._s(_vm.fb_users[_vm.fb_selected].firstname) + " " + _vm._s(_vm.fb_users[_vm.fb_selected].lastname))])]), _vm._v(" "), _c('p', [_vm._v("Godine: " + _vm._s(_vm.fb_users[_vm.fb_selected].age_range))]), _vm._v(" "), _c('p', [_vm._v("Nick: " + _vm._s(_vm.testUri(_vm.fb_users[_vm.fb_selected].nickname)))]), _vm._v(" "), _c('p', [_vm._v("ID: " + _vm._s(_vm.fb_users[_vm.fb_selected].id))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fb_selected_2),
      expression: "fb_selected_2"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.fb_selected_2 = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.fb_users), function(fb, index) {
    return (fb.id) ? _c('option', {
      domProps: {
        "value": index
      }
    }, [_vm._v(_vm._s(fb.firstname) + " " + _vm._s(fb.lastname) + " | id: " + _vm._s(fb.id))]) : _vm._e()
  })), _vm._v(" "), (_vm.fb_selected_2 > 0) ? _c('div', [_c('h3', [_vm._v("Ovaj nalog ostaje:")]), _vm._v(" "), _c('p', [_vm._v("Odabran korisnik: "), _c('a', {
    attrs: {
      "href": 'https://facebook.com/' + _vm.fb_users[_vm.fb_selected_2].facebook_id
    }
  }, [_vm._v(_vm._s(_vm.fb_users[_vm.fb_selected_2].firstname) + " " + _vm._s(_vm.fb_users[_vm.fb_selected_2].lastname))])]), _vm._v(" "), _c('p', [_vm._v("Godine: " + _vm._s(_vm.fb_users[_vm.fb_selected_2].age_range))]), _vm._v(" "), _c('p', [_vm._v("Nick: " + _vm._s(_vm.testUri(_vm.fb_users[_vm.fb_selected_2].nickname)))]), _vm._v(" "), _c('p', [_vm._v("ID: " + _vm._s(_vm.fb_users[_vm.fb_selected_2].id))])]) : _vm._e()])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4 col-sm-offset-4"
  }, [(_vm.fb_selected >= 0 && _vm.fb_selected_2 >= 0) ? _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.mergeAccounts()
      }
    }
  }, [_vm._v("Izvrsi zamenu naloga")]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("\n      Users\n      "), _c('small', [_vm._v("List of users")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ff7a7764!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/users/facebook.vue
// module id = 327
// module chunks = 2